<template>
  <div class="privacy-policy">
    <v-card
      outlined
      max-width="900"
      class="d-none d-sm-block mb-5"
    >
      <v-card-title>プライバシーポリシー</v-card-title>
    </v-card>
    <v-card
      outlined
      max-width="900"
    >
      <v-card-text>
        <section class="mb-5">
          <p>
            たそ（@taso0096）（以下、「当サービス提供者」といいます。）は、本ウェブサイト上で提供するサービス（以下、「本サービス」といいます。）
            における、ユーザーの個人情報もしくはそれに準ずる情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
          </p>
        </section>
        <section class="mb-5">
          <div class="title">
            第1条（基本方針）
          </div>
          <p>
            個人情報の重要性を認識し、個人情報を保護することが社会的責務であると考え、個人情報に関する法令を遵守し、
            本サービスで取り扱う個人情報の取得、利用、管理を適正に行います。
          </p>
        </section>
        <section class="mb-5">
          <div class="title">
            第2条（Cookie及びLocalStorage）
          </div>
          <p>
            本サービスの一部では、利用状況の把握のためにCookie及びLocalStorageを使用しています。
            主に、ブラウザでの投稿の再生時刻を記録しており、サーバーでの保存は行われていません。
            本機能は、Cookie及びLocalStorageを無効にすることで拒否することが出来ますので、お使いのブラウザの設定をご確認ください。
            ただし、Cookie及びLocalStorageを無効に設定をされている場合は、本サービスの機能が正常に動作しない場合がございます。
          </p>
        </section>
        <section class="mb-5">
          <div class="title">
            第3条（Google Analytics）
          </div>
          <p>
            本サービスでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。
            このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。
            こちらのトラフィックデータは匿名で収集されており、個人を特定するものではありません。
            本機能は、Cookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。
            この規約に関して、詳しくは「<a
              href="https://marketingplatform.google.com/about/analytics/terms/jp/"
              target="_blank"
              rel="noopener"
            >Google アナリティクス利用規約</a>」をご覧ください。
          </p>
        </section>
        <section class="mb-5">
          <div class="title">
            第4条（利用目的の変更）
          </div>
          <ol>
            <li>当サービス提供者は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。</li>
            <li>利用目的の変更を行った場合には、変更後の目的について、当サービス提供者所定の方法により、ユーザーに通知し、または本ウェブサイト上に公表するものとします。</li>
          </ol>
        </section>
        <section class="mb-5">
          <div class="title">
            第5条（プライバシーポリシーの変更）
          </div>
          <ol class="my-2">
            <li>本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。</li>
            <li>当サービス提供者が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。</li>
          </ol>
        </section>
        <section class="mb-5">
          <div class="title">
            第6条（お問い合わせ）
          </div>
          <p>
            こちらの「<a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdrID1XAqY-wUiAFe26nRAwpfcE_wN-wBcVzoUHgoUifCybFQ/viewform"
              target="_blank"
              rel="noopener"
            >Googleフォーム</a>」より回答をお願いいたします。
          </p>
        </section>
        <section class="mb-5">
          <div class="title">
            制定・改訂情報
          </div>
          <div class="my-2">
            <div>2020年5月10日 制定・発効</div>
          </div>
        </section>
        <div class="text-right">
          以上
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<style lang="scss">
.privacy-policy {
  > * {
    margin: auto;
  }
}
</style>

<script>
export default {
  data: () => ({

  })
};
</script>
